import { useTranslation } from "react-i18next";
import { DirectionIcon } from "@scryerlabs/ui";

interface StrategySideLabelProps {
  /** The strategy's direction. Unknown or absent renders nothing. */
  direction?: number;
  /**
   * Inside a strategy-sides list: the full words where the list is wide enough, one word (Long,
   * Short, Both) where it isn't. The list's width decides, through a container query in custom.scss.
   */
  fit?: boolean;
  iconSize?: number;
  className?: string;
}

/** Which side of a strategy this is, as its direction mark and the words for it. */
export function StrategySideLabel({ direction, fit = false, iconSize = 16, className }: StrategySideLabelProps) {
  const { t } = useTranslation("tradingStrategies");

  if (!direction) {
    return null;
  }

  const label = t(`sides.${direction}`);
  const shortLabel = t(`sidesShort.${direction}`);

  return (
    <span className={`d-inline-flex align-items-center gap-1 text-nowrap ${className ?? ""}`}>
      <DirectionIcon direction={direction} label={t(`traits.direction.${direction}`)} size={iconSize} />
      {fit ? (
        <>
          <span className="side-words-full">{label}</span>
          <span className="side-words-short">{shortLabel}</span>
        </>
      ) : (
        label
      )}
    </span>
  );
}
